import { DeliverySlotsCheckerUI } from "./DeliverySlotsCheckerUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { Product } from "../../types/types";
import {
  ensureIsActive,
  ensureIsActiveVariant,
} from "../../utils/product/ensureIsActive";

export function DeliverySlotsChecker({
  product,
  runtimeConfig,
  configProps,
}: Pick<StandardProps, "product" | "runtimeConfig" | "configProps">) {
  const { variant } = useVariant(product);
  const { electricalApiBaseUrl, availableSlotsApiBaseUrl } = runtimeConfig;

  const activeProduct = ensureIsActive(product);
  const activeVariant = ensureIsActiveVariant(variant);
  if (!activeProduct || !activeVariant) return null;

  const apiBaseUrl =
    configProps?.fetchSlotsFromSAF === true
      ? availableSlotsApiBaseUrl
      : electricalApiBaseUrl;

  if (
    activeVariant.availability.availableToOrder &&
    hasSchedulableDeliveryOption(product)
  ) {
    return (
      <DeliverySlotsCheckerUI
        availableSlotsBaseUrl={apiBaseUrl}
        skuId={activeVariant.aliases.skuId}
        variantPrice={activeVariant.price.value}
      />
    );
  }
  return null;
}

const hasSchedulableDeliveryOption = (product: Product): boolean => {
  const availableOptions = product.fulfilmentOptions?.available ?? [];
  return availableOptions.some((option) => option?.aliases?.dmsId === "26");
};
